import * as angular from "angular";
import {Webhook} from '../models/webhook.model';
import {WebhooksRequests} from "./webhooks-requests.service";

export class WebhooksDialogService {

  /* @ngInject */
  constructor(private $mdDialog) {
  }

  create(event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/webhooks-dialog.html').default,
      controller: function ($scope, webhooksRequests: WebhooksRequests, WebhooksConstants, $log) {

        $scope.webhook = {
          name: undefined,
          deliveryUrl: undefined,
          status: undefined,
          topics: [],
          updatedAt: undefined,
          customHeaders: []
        }
        $scope.title = 'Create Webhook';
        $scope.topics = [];
        $scope.statuses = WebhooksConstants.statuses;
        $scope.cancel = self.$mdDialog.cancel;

        $scope.onAddCustomHeader = () => {
          const customHeader = {
            key: undefined,
            value: undefined
          }
          $scope.webhook.customHeaders.push(customHeader);
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.webhook);
            }
          }
        };

        $scope.onTopicsSelect = (topics) => {
          $scope.webhook.topics = topics;
        }

      },
      targetEvent: event,
      clickOutsideToClose: false
    })
  }

  edit(webhook: Webhook, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/webhooks-dialog.html').default,
      controller: function ($scope, webhooksRequests, WebhooksConstants, $log) {

        $scope.webhook = angular.copy(webhook);
        $scope.topics = [];
        $scope.statuses = WebhooksConstants.statuses;
        $scope.title = 'Edit Webhook';
        $scope.cancel = self.$mdDialog.cancel;

        $scope.onAddCustomHeader = () => {
          const customHeader = {
            key: undefined,
            value: undefined
          }
          if (!$scope.webhook.customHeaders) {
            $scope.webhook.customHeaders = [];
          }
          $scope.webhook.customHeaders.push(customHeader);
        }

        $scope.onRemoveCustomHeader = (index : string) => {
          $scope.webhook.customHeaders.splice(index, 1);
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.webhook);
            }
          }
        };

        $scope.onTopicsSelect = (topics) => {
          $scope.webhook.topics = topics;
        }


      },
      targetEvent: event,
      clickOutsideToClose: false
    })
  }
}

angular
  .module('bringoz.admin.webhooks')
  .service('webhooksDialogService', WebhooksDialogService);
